import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin } from "lucide-react";
import { provinces } from "@/data/provinces";
import { countComuniInProvinces } from "@/data/comuni-stats";

const REGIONS_IT = [
  { slug: "toscana", label_it: "Toscana", label_en: "Tuscany", region: "Toscana" },
  { slug: "liguria", label_it: "Liguria", label_en: "Liguria", region: "Liguria" },
  { slug: "umbria", label_it: "Umbria", label_en: "Umbria", region: "Umbria" },
  { slug: "lazio", label_it: "Alto Lazio", label_en: "Northern Lazio", region: "Lazio" },
];

function RegionHubCard({ region, lang }) {
  const provSlugs = provinces.filter((p) => p.region === region.region).map((p) => p.slug);
  const count = countComuniInProvinces(provSlugs);
  const label = lang === "it" ? region.label_it : region.label_en;
  return (
    <Link to={`/${region.slug}`} data-testid={`home-region-hub-${region.slug}`}>
      <Card className="p-4 card-hover h-full min-h-[88px] flex flex-col justify-between">
        <div className="flex items-center gap-2">
          <MapPin className="h-4 w-4 text-[hsl(var(--brand-aqua))]" />
          <span className="font-semibold text-[hsl(var(--brand-navy))]">{label}</span>
        </div>
        <div className="mt-2 text-xs text-[hsl(var(--muted-foreground))]">
          {count} {lang === "it" ? "comuni · reperibilità telefonica H24" : "municipalities · 24/7 phone availability"}
        </div>
      </Card>
    </Link>
  );
}

export function HomeCoverage({ t, lang }) {
  return (
    <section className="max-w-[1120px] mx-auto px-4 sm:px-6 mt-14">
      <h2 className="text-2xl sm:text-3xl font-semibold text-[hsl(var(--brand-navy))]">{t("home.coverage_title")}</h2>
      <p className="text-sm sm:text-base text-[hsl(var(--muted-foreground))] mt-1">{t("home.coverage_sub")}</p>

      <div className="mt-5 grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="home-region-hubs">
        {REGIONS_IT.map((r) => <RegionHubCard key={r.slug} region={r} lang={lang} />)}
      </div>

      <div className="mt-6 flex flex-wrap gap-2" data-testid="home-coverage-chips">
        {provinces.map((p) => (
          <Link key={p.slug} to={`/zone/${p.slug}`} data-testid={`home-province-chip-${p.slug}`}>
            <Badge variant="secondary" className="text-sm font-medium px-3 py-1.5 bg-white border border-[hsl(var(--border))] hover:bg-[hsl(var(--accent))] cursor-pointer">
              <MapPin className="h-3.5 w-3.5 mr-1 text-[hsl(var(--brand-aqua))]" /> {p.name}
            </Badge>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default HomeCoverage;
